import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionA8');

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCard
                layout="center-left"
                title={t('title')}
                desc={t('desc')}
                lChildren={t('btn1')}
                pc="https://websiteoss.ecoflow.com/upload/image/1741260139616/image.jpg"
            />
        </div>
    );
}
